/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import CancelAction from './CancelAction/index'
import CloseAction from './CloseAction/index'
import DeleteAction from './DeleteAction/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/DeleteAction/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let eventActionActionExecutionsValueData = fromData.useDataFormat({ viewPath,
context: 'event_action',
path: 'action_executions',
format: fromFormat.isEmptyList,
})
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="auto"
 width={400}
 borderBottomLeftRadius={dtSpaceXs}
 borderBottomRightRadius={dtSpaceXs}
 borderTopLeftRadius={dtSpaceXs}
 borderTopRightRadius={dtSpaceXs}
 paddingTop={0}
 paddingRight={0}
 paddingBottom={0}
 paddingLeft={0}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-4-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--bbc-5-Z1Yf8zk': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 color={dtColorsNeutral900}
 text="Delete action"
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-6-Z1Yf8zk': dtColorsNeutral100,'--pt-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pb-2-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-3-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-4-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="regular"
 size="xmedium"
 marginBottom={dtSpaceS}
 text={eventActionActionExecutionsValueData ? "Are you sure you want to delete this action?" : "This action has already been executed in the past. Deleting the action will also delete the information for those executions. Do you still want to proceed?"}
 data="event_action.action_executions"
 format="/Data/format.js isEmptyList"
/>
</div>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-4-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--btc-7-Z1Yf8zk': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal1}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
<DeleteAction
  viewPath={`${viewPath}/DeleteAction`}
/>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}